/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useFormatters } from "../../hooks/useFormatters";
import { formatDateTime as formatDateTimeUtil } from "../../utils/helpers/formatters";

const FormatDateTime = ({ value, format }) => {
  const { FormatDateTime } = useFormatters();

  return FormatDateTime({ value, format });
};

FormatDateTime.FORMAT = formatDateTimeUtil.FORMAT;
FormatDateTime.TYPE = formatDateTimeUtil.TYPE;

export default FormatDateTime;
